import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const MoreCards = () => {
  const { region } = useParams(); // gets 'Dubai', 'Japan', etc.
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    import('../../../Data/International/FeaturedDestination').then((module) => {
      const data = module.default;
      const regionPackages = data[region]; // e.g., data['Dubai']
      if (regionPackages) {
        setPackages(regionPackages);
      }
    });
  }, [region]);

  return (
    <div className="mt-44 mb-20">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-extrabold text-center text-yellow-700 mb-12 mt-20 p-1"
      >
        {region} Packages
      </motion.h2>

      <div className="flex flex-wrap justify-center items-center m-auto px-4">
        {packages.map((pkg, index) => (
          <motion.div
            key={pkg.id}
            className="w-full sm:w-72 md:w-80 lg:w-96 m-4 bg-white/40 backdrop-blur-md border border-white/20 rounded-3xl shadow-md hover:shadow-lg transition-transform transform hover:scale-105 overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <img
              src={pkg.images[0]}
              alt={pkg.title}
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
            />
            <div className="p-4">
              <h4 className="text-xl font-bold text-yellow-800">{pkg.title}</h4>
              <p className="text-sm text-gray-700 mt-2">{pkg.description}</p>
              <p className="text-yellow-600 font-medium mt-2">{pkg.tripDuration}</p>
              <Link
                to={`/${region}/${pkg.id}`}
                className="inline-block mt-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-5 py-2 rounded-full shadow-md hover:shadow-lg transition duration-300"
              >
                View More
              </Link>
            </div>
          </motion.div>
        ))}
      </div>


       
    </div>
  );
};

export default MoreCards;
